/** @import {Account, Product} from "../contexts/CustomerDataProviderTypes" */

export const getRolloverRateForProduct = (/** @type {Product | undefined} */product,/** @type {Account} */ account) => {
    let rolloverRate = 0;
    if (account.maturity && account.maturity.availableRolloverRates && product) {
        const rolloverProduct = account.maturity.availableRolloverRates.find(r => r.productId === product.id);
        if (rolloverProduct) {
            rolloverRate = rolloverProduct.rate;
        }
    }
    return rolloverRate;
};

export const getCalculatedInterest = (/** @type {Account} */ maturingAccount) => {
    if (!maturingAccount.maturity?.calculatedTotalInterest && maturingAccount.maturity?.calculatedBalanceAtMaturity) {
        return maturingAccount.maturity?.calculatedBalanceAtMaturity - maturingAccount.balance;
    }
    return maturingAccount.maturity?.calculatedTotalInterest;
};

export const getCurrentBalanceWithCalculatedInterest = (/** @type {Account} */ maturingAccount) => {
    if (!maturingAccount.maturity?.calculatedTotalInterest) {
        return maturingAccount.maturity?.calculatedBalanceAtMaturity;
    }
    const currentBalance = maturingAccount.balance;
    const calculatedMaturity = maturingAccount.maturity.calculatedTotalInterest;
    return currentBalance + calculatedMaturity;
};